// extracted by mini-css-extract-plugin
module.exports = {"RowBox_left":"index_RowBox_left__PpBeJ","RowBox_right":"index_RowBox_right__T4GM4"};